
import {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import parse from "html-react-parser";
import NavigationButtons from "../../Components/Layout/Elements/NavigationButtons";
import applicationSite from "../../assets/img/Sensor/application-site-selection-sm.png"
import './../../assets/css/Sensor/Sensor.css'
import ModalNote from "../../Components/Modal/ModalNote";
import {HiExclamationTriangle} from "react-icons/hi2";
import {useTranslation} from "../../Utils/UseTranslation";

const ApplicationSiteSelection = () => {
    const {t, i18n} = useTranslation()
    const [show, setShow]= useState(false);
    const [title, setTitle] = useState()
    const [text, setText] = useState()
    const handleClose = () => {
        setShow(false)
    }
    return (
        <>
            <Col md={6} className={'text-start ps-4'}>

                <h2> {t("applicationSiteSelect")}</h2>


                <p className={''}>
                    <span>{parse(t("applicationSiteSelect_Text_1"))}  </span>
                    <span>
                         <HiExclamationTriangle className={'fs-3 text-end text-orange'} onClick={() => {
                             setShow(true)
                             setTitle(t('caution'))
                             setText(t("applicationSiteSelect_caution"))
                         }}/>
                    </span>
                </p>


                <p className={'mb-3 d-flex align-items-center justify-content-between'}>
                    <span>{parse(t("applicationSiteSelect_Text_2"))}</span>


                </p>


            </Col>
            <Col md={5} className={'align-self-start position-relative'}>


                <img src={applicationSite} className={'img-fluid w-100 border'}/>
                <div className={'applySensorImgTxt'}><p className={'text-start '}>{t("onlyApply")}</p>
                </div>

            </Col>
            <Col md={12} className={'text-start align-self-end'}>
                <NavigationButtons t={t} prevUrl={'/professional-options'} nextUrl={'/preparing-application-site'}/>
            </Col>
            <ModalNote show={show}  handleClose={handleClose} text={text} title={title}></ModalNote>
        </>


    )
}

export default ApplicationSiteSelection